var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login-change" } }, [
    _vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: _vm.$ceres.urls.myAccount,
                title: _vm.$translate("Ceres::Template.loginMyAccount"),
                id: "accountMenuList",
                "data-boundary": "window"
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "header-controls__icon",
                  attrs: { width: "20", height: "20" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_user",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.loginMyAccount")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _c(
            "a",
            {
              attrs: {
                "data-toggle": "modal",
                href: _vm.isLogin ? "javascript:void(0)" : "#login",
                title: "Login",
                "aria-label": _vm.$translate("Ceres::Template.login")
              },
              on: {
                click: function($event) {
                  _vm.createLoginModal()
                  _vm.unmarkInputFields()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "header-controls__icon",
                  attrs: { width: "20", height: "20" }
                },
                [
                  _c("use", {
                    attrs: {
                      "xlink:href": "#svg_user",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.login")))
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }